export default {
  computed: {
    reachedMin() {
      return this.min === this.count
    },
    reachedMax() {
      return this.max === this.count
    }
  },
  data() {
    return {
      newData: [],
      localData: this.data,
      count: this.data.length || this.min,
      componentKey: 0,
    };
  },
  methods: {
    replicate(index, data = '') {
      if (this.max === null || this.count < this.max) {
        if (typeof index === 'undefined' || index === null) {
          if(data != ''){
            this.localData.push(data);
          }else{
            this.localData.push(data);
          }
        } else {
          this.localData.splice(index + 1, 0, data);
        }
        
        this.count++;
      }
      
    },
    reduce(index, number, pop = false) {      
      if (this.count > this.min) {
        if (typeof index !== 'undefined' && typeof number !== 'undefined' && index !== null && number !== null) {
          this.localData.splice(index, number);
          this.forceListUpdate();
        } else {
          if(pop){
            this.localData.pop();
          }else{
            this.localData = this.localData.slice(0, this.localData.length - 1);
          }
        }
        this.count--;
      }
    },
    clear() {
      this.count = this.min;
    },
    forceListUpdate() {
      this.componentKey += 1;
    },
  },
  created() {
    if (this.watchChanges) {
      this.$root.$on('updateReplicatorState', (i, val) => {
        if (typeof this.localData[i] === 'string') {
          this.localData[i] = val;
        } else if (this.localData[i] !== 'undefined') {
          this.localData[i].tag = val;
        }
      });
    }
    if (this.watchSave) {
      this.$root.$on('updateLandlordAndSubscription', () => {
        this.newData.length = 0;
        for (var i = 0; i < this.localData.length; i++) {
          if (typeof this.localData[i] === 'string') {
            if (this.localData[i] !== '') this.newData.push(this.localData[i]);
          } else {
            if (this.localData[i].tag !== '') this.newData.push(this.localData[i].tag);
          }
        }
        this.localData.length = 0;
        for (var i = 0; i < this.newData.length; i++) {
          let obj = {};
          obj.tag = this.newData[i]
          this.localData.push(obj);
        }
        this.count = this.localData.length;
      });
    }
  },
  props: {
    min: {
      default: 1,
      type: Number
    },
    max: {
      default: null,
      type: Number
    },
    data: {
      default: () => { return [] },
      type: Array
    },
    watchSave: {
      default: false,
      type: Boolean
    },
    watchChanges: {
      default: false,
      type: Boolean
    },
  },
}


// WEBPACK FOOTER //
// ./resources/assets/js/admin/mixins/replicator.js